import { ProductRatingsEnum } from '../enums/productRatings.enum';

export const PRODUCT_RATING_LABELS: Readonly<Record<ProductRatingsEnum, string>> = Object.freeze({
  [ProductRatingsEnum.QUALITY]: "Qualità d’Immagine",
  [ProductRatingsEnum.TECHNOLOGY]: 'Tecnologia e Funzioni',
  [ProductRatingsEnum.RESPONSIVENESS]: 'Reattività',
  [ProductRatingsEnum.VFM]: 'Qualità/Prezzo',
  [ProductRatingsEnum.LENS_ZOOM]: 'Obiettivo / Zoom',
  [ProductRatingsEnum.COMPACTNESS]: 'Compattezza',
});
